import {
  HeroModulePreTitle,
  HeroModuleTitle,
  HeroModuleText,
  HeroModuleCallToAction,
} from '../../innerComponents';
import { Image, ModernCard, Wrapper } from './styles';

export function ModernCardDisplayContent(props) {
  const {
    section: {
      subText: preTitle,
      valueProposition: title,
      titleSize,
      text,
      primaryLink,
      type,
      displayType,
    },
    backgroundImagePath,
  } = props;

  return (
    <Wrapper className="lazy" data-background-image={backgroundImagePath}>
      <Image>
        <img src={backgroundImagePath} alt="" />
      </Image>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-6">
            <ModernCard>
              <HeroModulePreTitle text={preTitle} />
              <HeroModuleTitle text={title} as={titleSize} />
              <HeroModuleText text={text} />
              <HeroModuleCallToAction
                primaryCTAConfig={primaryLink}
                moduleType={type}
                displayType={displayType}
              />
            </ModernCard>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
